export function getValueByPath(obj: any, path: string) {
  // Split the path into an array of keys
  const keys = path.split(".");

  // Traverse the object step by step
  return keys.reduce((acc, key) => acc && acc[key], obj);
}

export function setValueByPath(obj: any, path: string, value: any): any {
  const keys = path.split(".");
  let current = obj;

  keys.forEach((key, index) => {
    // If we're at the last key, set the value
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      // If the key doesn't exist, create an empty object or array
      if (!current[key]) {
        current[key] = isNaN(Number(keys[index + 1])) ? {} : [];
      }
      current = current[key];
    }
  });

  return obj;
}

export function formatDate(dateString: string): string {
  // Handle both formats: "2026-02-25" and "20260225"
  let date: Date;
  if (dateString.includes("-")) {
    // Format: "2026-02-25"
    date = new Date(dateString);
  } else {
    // Format: "20260225"
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    date = new Date(`${year}-${month}-${day}`);
  }
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatTime(dateString: string): string {
  return new Date(dateString).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
}

export function isRecentlyCreated(dateString: string, withinDays = 7): boolean {
  const diffDays = (Date.now() - new Date(dateString).getTime()) / 86400000;
  return diffDays <= withinDays;
}

export type ActivityRecencyTier = "today" | "week" | "month" | "stale";

export function getActivityRecencyTier(lastActiveDate: string | null): ActivityRecencyTier {
  if (!lastActiveDate) return "stale";
  const date = lastActiveDate.includes("-")
    ? new Date(lastActiveDate)
    : new Date(
        `${lastActiveDate.substring(0, 4)}-${lastActiveDate.substring(4, 6)}-${lastActiveDate.substring(6, 8)}`
      );
  const diffDays = Math.floor((Date.now() - date.getTime()) / 86400000);
  if (diffDays <= 0) return "today";
  if (diffDays < 7) return "week";
  if (diffDays < 30) return "month";
  return "stale";
}

export function formatRelativeTime(dateString: string): string {
  const date = dateString.includes("-")
    ? new Date(dateString)
    : new Date(
        `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`
      );
  const diffDays = Math.floor((Date.now() - date.getTime()) / 86400000);

  if (diffDays <= 0) return "Today";
  if (diffDays === 1) return "1 day ago";
  if (diffDays < 30) return `${diffDays} days ago`;
  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths === 1) return "1 month ago";
  if (diffMonths < 12) return `${diffMonths} months ago`;
  const diffYears = Math.floor(diffMonths / 12);
  return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`;
}
